import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { CampaignType } from '../../typings/domain';
import { CampaignTypesList } from '../CampaignTypesList/CampaignTypesList';

import './AddCampaignTypeMenu.css';
import * as keyset from './AddCampaignTypeMenu.i18n';

const i18n = i18nFactory(keyset);

export interface AddCampaignTypeMenuProps {
    availableCampaignTypes: CampaignType[];
    onClick?: (campaignType: CampaignType) => void;
}

export class AddCampaignTypeMenu extends React.Component<AddCampaignTypeMenuProps> {
    render() {
        const { availableCampaignTypes, onClick } = this.props;

        if (onClick === undefined) {
            return null;
        }

        return (
            <div className={Bem.cls('add-campaign-type-menu')}>
                <div className={Bem.cls('add-campaign-type-menu', 'title')}>{i18n('choose-campaign-type')}</div>
                <CampaignTypesList availableCampaignTypes={availableCampaignTypes} onClick={this.onClick} />
            </div>
        );
    }

    private onClick = (type: CampaignType) => {
        const { onClick } = this.props;

        if (onClick !== undefined) {
            onClick(type);
        }
    };
}
